/**
Project: Voice Panel (c)
Title: Intl Translate 
Description: Helper class with functions for translation 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import { useTranslation } from "react-i18next";

export default function IntlTranslate({ namespace, keyId }) {
  const { t } = useTranslation(namespace, { useSuspense: false });
  if (t) return <>{t(keyId)}</>;
  else return null;
}
